import { actionConst } from '../../constants/new-document.constants';

const initialStateDrawer = {
  visible: false,
  mode: null, // 'edit' | 'create'
  documentId: null,
  formValues: null,
  savedDraft: null,
};

const defaultState = {
  listAddrStreet: [],
  listAddrBuilding: [],
  listAddrFlat: [],
  valueAddrStreet: undefined,
  valueAddrBuilding: undefined,
  valueAddrFlat: undefined,
  newDocumentModalVisible: false,
  listDocumentType: [],
  listOrdType: [],
  listOssType: [],
  listContractType: [],
  listExecuter: [],
  responsibleWorkers: [],
  request: null,
  posted: false,
  updatedDocument: null,
  contractorId: undefined,
  postDocumentID: undefined,
  listServiceCompanies: [],
  listDocumentVisibility: [],
  visibleDocumentDrawer: null,
  documentDrawer: initialStateDrawer,
  chosenFilterId: null,
  chosenFilterName: null,
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actionConst.RESET_POSTED_DOCUMENT: {
      return {
        ...state,
        postDocumentID: null,
      };
    }
    case actionConst.SET_DOCUMENTS_CHOSEN_FILTER: {
      return {
        ...state,
        chosenFilterId: action?.payload?.id || null,
        chosenFilterName: action?.payload?.name || null,
      };
    }
    case actionConst.POST_DOCUMENT: {
      return {
        ...state,
        postDocumentID: action.payload,
      };
    }
    case actionConst.FETCH_ADDR_STREET_REF + '_FULFILLED': {
      return {
        ...state,
        listAddrStreet: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_ADDR_BUILDING_REF + '_FULFILLED': {
      return {
        ...state,
        listAddrBuilding: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_ADDR_FLAT_REF + '_FULFILLED': {
      return {
        ...state,
        listAddrFlat: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.APPLY_ADDR_STREET: {
      return {
        ...state,
        valueAddrStreet: action.payload,
      };
    }
    case actionConst.SET_ADDR_BUILDING_VALUE: {
      return {
        ...state,
        valueAddrBuilding: action.payload,
      };
    }
    case actionConst.SET_ADDR_FLAT_VALUE: {
      return {
        ...state,
        valueAddrFlat: action.payload,
      };
    }
    case actionConst.FETCH_DOCTYPE_REF + '_FULFILLED': {
      return {
        ...state,
        listDocumentType: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_ORDTYPE_REF + '_FULFILLED': {
      return {
        ...state,
        listOrdType: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_OSS_TYPE_REF + '_FULFILLED': {
      return {
        ...state,
        listOssType: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_CONTRACT_TYPE_REF + '_FULFILLED': {
      return {
        ...state,
        listContractType: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_EXECUTER_REF + '_FULFILLED': {
      return {
        ...state,
        listExecuter: action.payload.data.data || action.payload.data,
      };
    }

    case actionConst.VISIBLE_DOCUMENT_DRAWER: {
      return {
        ...state,
        visibleDocumentDrawer: action.payload,
      };
    }

    case actionConst.FETCH_RESPONSIBLE_WORKERS: {
      return {
        ...state,
        responsibleWorkers: action.payload,
      };
    }
    case actionConst.OPEN_NEW_DOCUMENT_MODAL: {
      return {
        ...state,
        newDocumentModalVisible: true,
        request: action.payload,
        contractorId: action.contractorId,
        posted: false,
      };
    }
    case actionConst.CLOSE_NEW_DOCUMENT_MODAL: {
      return {
        ...state,
        newDocumentModalVisible: false,
      };
    }
    case actionConst.FETCH_SERVICE_COMPANIES_LIST + '_FULFILLED': {
      return {
        ...state,
        listServiceCompanies: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.FETCH_DOCUMENT_VISIBILITY_LIST + '_FULFILLED': {
      return {
        ...state,
        listDocumentVisibility: action.payload.data.data || action.payload.data,
      };
    }
    case actionConst.OPEN_EDIT_DOCUMENT: {
      return {
        ...state,
        documentDrawer: {
          ...state.documentDrawer,
          visible: true,
          mode: 'edit',
          documentId: action.payload.documentId,
          formValues: action.payload.formValues || {},
          savedDraft: null,
        },
      };
    }
    case actionConst.OPEN_CREATE_DOCUMENT: {
      const { documentDrawer } = state;

      if (documentDrawer.mode === 'edit' && documentDrawer.documentId) {
        return {
          ...state,
          documentDrawer: {
            ...documentDrawer,
            visible: true,
            mode: 'create',
            documentId: null,
            formValues: {},
            savedDraft: {
              documentId: documentDrawer.documentId,
              values: documentDrawer.formValues || {},
            },
          },
        };
      }

      return {
        ...state,
        documentDrawer: {
          ...documentDrawer,
          visible: true,
          mode: 'create',
          documentId: null,
          formValues: {},
          savedDraft: null,
        },
      };
    }
    case actionConst.OPEN_DOCUMENT_CREATE_BY_RELATED: {
      const { documentDrawer } = state;

      return {
        ...state,
        documentDrawer: {
          ...documentDrawer,
          visible: true,
          mode: 'create',
          documentId: null,
          formValues: {},
          savedDraft: {
            documentId: action.payload.documentId,
            values: action.payload.doc || {},
          },
        },
      };
    }
    case actionConst.CLOSE_DOCUMENT_DRAWER: {
      const { documentDrawer } = state;

      if (documentDrawer.mode === 'create' && documentDrawer.savedDraft) {
        return {
          ...state,
          documentDrawer: {
            ...documentDrawer,
            visible: true,
            mode: 'edit',
            documentId: documentDrawer.savedDraft.documentId,
            formValues: documentDrawer.savedDraft.values,
            savedDraft: null,
          },
        };
      }

      return {
        ...state,
        documentDrawer: {
          ...initialStateDrawer,
        },
      };
    }
    case actionConst.UPDATE_FORM_VALUES: {
      return {
        ...state,
        documentDrawer: {
          ...state.documentDrawer,
          formValues: action.payload,
        },
      };
    }
    default:
      return state;
  }
};
